
export const comeContattarciOrari = [
  {
    day: 'Lunedì',
    from: '9',
    to: '17',
  },
  {
    day: 'Martedì',
    from: '9',
    to: '17',
  },
  {
    day: 'Mercoledì',
    from: '9',
    to: '13',
  },
  {
    day: 'Giovedì',
    from: '9',
    to: '17',
  },
  {
    day: 'Venerdì',
    from: '9',
    to: '17',
  },
];
